// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-body-logout {
  position: absolute;
  width: auto;
  background-color: white;
  border-radius: 0.6vw;
  padding: 1.3vw;
  outline: none;
  border: none;
}

.modal-heading {
  font-family: "Poppins" !important;
  font-weight: 500 !important;
  font-size: .9vw !important;
  letter-spacing: -0.2px !important;
  line-height: 140% !important;
  text-align: center !important;
}

.btn-modal {
  display: flex !important;
  margin-top: 1.2vw !important;
}

.btn {
  color: black !important;
  border-radius: 0.25vw !important;
  padding: 0.9vw 4.35vw !important;
  font-family: "Poppins" !important;
  font-weight: 600 !important;
  font-size: 0.8vw !important;
  line-height: 100% !important;
  text-transform: capitalize !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/modals/LogoutandDeleteModal/logoutandDelete.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,qCAAqC;AACvC","sourcesContent":[".modal-body-logout {\n  position: absolute;\n  width: auto;\n  background-color: white;\n  border-radius: 0.6vw;\n  padding: 1.3vw;\n  outline: none;\n  border: none;\n}\n\n.modal-heading {\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n  font-size: .9vw !important;\n  letter-spacing: -0.2px !important;\n  line-height: 140% !important;\n  text-align: center !important;\n}\n\n.btn-modal {\n  display: flex !important;\n  margin-top: 1.2vw !important;\n}\n\n.btn {\n  color: black !important;\n  border-radius: 0.25vw !important;\n  padding: 0.9vw 4.35vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 600 !important;\n  font-size: 0.8vw !important;\n  line-height: 100% !important;\n  text-transform: capitalize !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
